const Constants = {
  endpointBasePath: "/case-decisions",
  caseDecisionTypesPath: "/case-decision-types",
  indexCategoriesPath: "/index-categories",
  attachmentPath: "/attachments"
};
const CaseDecisionStatus = {
  IN_PROGRESS: "IN_PROGRESS",
  RECORDED: "RECORDED",
  VERIFIED: "VERIFIED",
  PUBLISHED: "PUBLISHED",
  ARCHIVED: "ARCHIVED",
  INVALIDATED: "INVALIDATED"
};
const ContentTypes = {
  ATTACHMENT_CONTENT_TYPE: "ATTACHMENT_CONTENT_TYPE",
  FILE_CONTENT_TYPE: "DATOTEKA",
  URL_CONTENT_TYPE: "URL"
};
export default Constants;
export { CaseDecisionStatus, ContentTypes };
